exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table__row--txs .from-address-arrow a,.table__row--txs .from-address-arrow span{min-width:65%}.table__row--txsHome .from-address-arrow a,.table__row--txsHome .from-address-arrow span{min-width:95px}.link{font-weight:700;color:#0393f4;cursor:pointer;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb721502","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/contents/shared/TableSlotTransfer.vue
// module id = 285
// module chunks = 0